import { useConnectFacebookIdentity } from 'hooks/useConnectFacebookIdentity';
import FaceBookIcon from 'svg/FaceBookIcon';
import { Button } from 'components/Button';
import ModalField from './ModalField';
import ProfileFormModal from './ProfileFormModal';

interface Props {
  isOpen: boolean;
  /** Already earned the badge — linking again would be a no-op. */
  isVerified: boolean;
  onClose: () => void;
  /** Refetches the profile so the badge appears without a reload. */
  onVerified: () => void;
}

/**
 * Identity checks that earn the trust badges. Nothing is captured here: each
 * route hands off elsewhere and reports back through its own record, so the
 * modal has no Save of its own.
 */
export default function VerificationFormModal({ isOpen, isVerified, onClose, onVerified }: Props) {
  const {
    connectFacebook,
    isLinking,
    error: facebookError,
  } = useConnectFacebookIdentity({ onLinked: onVerified });

  return (
    <ProfileFormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Verification"
      description="We take safety seriously. Verify your identity to connect with more players."
      error={facebookError}
    >
      {/* Government ID + Selfie (Stripe Identity) is hidden until that flow is built. */}
      <ModalField label="Verify with Facebook">
        <Button
          type="button"
          variant="secondary"
          size="lg"
          loading={isLinking}
          disabled={isVerified}
          onClick={() => void connectFacebook()}
          iconLeft={<FaceBookIcon className="h-5 w-5 text-[#1877F2]" />}
        >
          {isVerified ? 'Connected with Facebook' : 'Connect with Facebook'}
        </Button>
      </ModalField>
    </ProfileFormModal>
  );
}
